import { ConfirmModal } from '@components/ConfirmModal';
import { useRemoveUserFromOrganization } from '@hooks/apiHooks/userHooks';
import { showToast } from '@utils/toast';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { IOrganizationMember } from '../../../../api/user';

interface RemoveMemberModalProps {
  isOpen: boolean;
  onClose: () => void;
  member: IOrganizationMember | null;
  organizationId: string;
}

const RemoveMemberModal: FC<RemoveMemberModalProps> = ({
  isOpen,
  onClose,
  member,
  organizationId,
}) => {
  const { t } = useTranslation();
  const { mutate: removeUser, isPending } = useRemoveUserFromOrganization();

  if (!member) return null;

  const handleRemove = () => {
    removeUser(
      {
        organizationId,
        userId: member.id,
      },
      {
        onSuccess: () => {
          showToast.success(t('account.userRemoved'));
          onClose();
        },
        onError: (error: any) => {
          const errorMessage =
            error?.response?.data?.message ||
            error?.message ||
            t('account.removeFailed');
          showToast.error(errorMessage);
        },
      },
    );
  };

  return (
    <ConfirmModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={handleRemove}
      title={t('account.removeMember')}
      message={
        <p>
          {t('account.removeConfirmation', { name: `${member.firstName} ${member.lastName}` })}
        </p>
      }
      confirmText={t('account.remove')}
      confirmButtonClass="bg-red-500 hover:bg-red-600"
      isLoading={isPending}
    />
  );
};

export default RemoveMemberModal;
